import React, { useState } from "react";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";

import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material";
import moment from "moment";
import { API } from "../../utils/http";
function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}
function getComparator(order, orderBy) {
	return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
const headCells = [
	{
		id: "createdTime",
		numeric: false,
		disablePadding: false,
		label: "Created Time",
	},
	{
		id: "firstName",
		numeric: false,
		disablePadding: false,
		label: "First Name",
	},
	{
		id: "lastName",
		numeric: false,
		disablePadding: false,
		label: "Last Name",
	},
	{
		id: "status",
		numeric: false,
		disablePadding: false,
		label: "Status",
	},
];
export default function RecordHistoryTable(props) {
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("calories");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const { rows, removeAddress, editAddress } = props;
	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	const handleDownloadPKPass = (row) => {
		console.log("download pkpass for row: ", row);
		API.get(`pkpass/${row.uuid}`)
			.then((r) => {
				console.log(r);
				const base64Pdf = r.data;
				console.log(base64Pdf);

				const binaryString = window.atob(base64Pdf); // Comment this if not using base64
				const bytes = new Uint8Array(binaryString.length);
				const arrayBuffer = bytes.map((byte, i) => binaryString.charCodeAt(i));

				var blob = new Blob([arrayBuffer], {
					type: "application/vnd.apple.pkpass",
				});
				var link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				var fileName = "CriminalRecordsCheckPass";
				link.download = fileName;
				link.click();
			})

			.catch((e) => {
				console.log(e);
			});
	};
	const handleDownloadPDF = (row) => {
		console.log("download pdf for row: ", row);
		API.get(`pdf/${row.uuid}`)
			.then((r) => {
				console.log(r);
				const base64Pdf = r.data;
				console.log(base64Pdf);

				const binaryString = window.atob(base64Pdf); // Comment this if not using base64
				const bytes = new Uint8Array(binaryString.length);
				const arrayBuffer = bytes.map((byte, i) => binaryString.charCodeAt(i));

				var blob = new Blob([arrayBuffer], {
					type: "application/pdf",
				});
				var link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				var fileName = "CriminalRecordsCheck";
				link.download = fileName;
				link.click();
			})

			.catch((e) => {
				console.log(e);
			});
	};
	const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		// backgroundColor: "#ebebeb",
		whiteSpace: "nowrap",
		"&:nth-of-type(even)": {
			backgroundColor: "#ebebeb",
		},
	}));
	return (
		<React.Fragment>
			<Box sx={{ width: "100%" }}>
				<Paper sx={{ width: "100%", mb: 2, borderRadius: "8px" }}>
					<TableContainer sx={{ borderRadius: "inherit" }}>
						<Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"medium"}>
							<EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={rows.length} />
							<TableBody>
								{/* stableSort(rows, getComparator(order, orderBy)) */}
								{rows.length > 0 ? (
									rows
										.slice()
										.sort(getComparator(order, orderBy))
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											return (
												<StyledTableRow tabIndex={-1} key={index}>
													<TableCell>{moment(row.createdTime).format("MMM DD YYYY - HH:mm")}</TableCell>
													<TableCell>{row.firstName}</TableCell>
													<TableCell>{row.lastName}</TableCell>
													<TableCell>{row.status}</TableCell>

													<TableCell>
														<IconButton
															disabled={row.status.toLowerCase() != "approved"}
															color="secondary"
															onClick={() => {
																handleDownloadPDF(row);
															}}
														>
															<DownloadIcon />
														</IconButton>
													</TableCell>
													<TableCell
														sx={{
															display: { xs: "table-cell", md: "none" },
														}}
													>
														<IconButton
															disabled={row.status.toLowerCase() != "approved"}
															color="secondary"
															onClick={() => {
																handleDownloadPKPass(row);
															}}
														>
															<DownloadIcon />
														</IconButton>
													</TableCell>
												</StyledTableRow>
											);
										})
								) : (
									<TableRow>
										<TableCell colSpan={8} align="center">
											No completed applications
										</TableCell>
									</TableRow>
								)}
								{/* {emptyRows > 0 && (
									<TableRow
										style={{
											height: 53 * emptyRows,
										}}
									>
										<TableCell colSpan={6} />
									</TableRow>
								)} */}
							</TableBody>
						</Table>
					</TableContainer>
					{/* <TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={rows.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/> */}
				</Paper>
			</Box>
		</React.Fragment>
	);
}
function EnhancedTableHead(props) {
	const { order, orderBy, onRequestSort } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	const StyledTableHead = styled(TableHead)(({ theme }) => ({
		backgroundColor: theme.palette.primary.faded,
		color: theme.palette.primary.main,
		fontWeight: "bold",
	}));
	return (
		<StyledTableHead>
			<TableRow>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{
							color: "inherit",
							fontWeight: "inherit",
							whiteSpace: "nowrap",
						}}
					>
						<TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={createSortHandler(headCell.id)}>
							{headCell.label}
							{orderBy === headCell.id ? (
								<Box component="span" sx={visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
				<TableCell
					style={{
						color: "inherit",
						fontWeight: "inherit",
						whiteSpace: "nowrap",
					}}
				>
					PDF
				</TableCell>
				<TableCell
					style={{
						color: "inherit",
						fontWeight: "inherit",
						whiteSpace: "nowrap",
					}}
					sx={{
						display: { xs: "table-cell", md: "none" },
					}}
				>
					Mobile Wallet
				</TableCell>
			</TableRow>
		</StyledTableHead>
	);
}
